import dayjs from "dayjs";
import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { LopDaoTao, NhanVienTheoLopDaoTao } from "../models/daotao/LopDaoTao";
import intance from "../utils/axios";

export const layDsTongHopDangKyDaoTao = async () => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layDSTongHopDangKyDaoTao)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};


export const lanhDaoPhongTrinhDangKyDaoTao = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.dangKyDaoTao.lanhDaoPhongTrinhDangKyDaoTao, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

/**
 * Lãnh đạo phòng duyệt / từ chối các chi tiết đăng ký đào tạo được chọn
 * @param request { isDuyet, lyDo, danhSachDuyet: id chi tiết đăng ký }
 */
/**
 * Gộp các dòng đăng ký đào tạo giống nhau thành 1 lớp
 * @param request { idChiTietGoc, idChiTiets, chuyenDe, noiDung, coSoDaoTao, thoiGianDuKien, duTruKinhPhi }
 */
export const gopLopDangKyDaoTao = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.dangKyDaoTao.gopLopDangKyDaoTao, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}

export const lanhDaoPhongDuyetCTDangKyDaoTao = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.dangKyDaoTao.lanhDaoPhongDuyetCTDangKyDaoTao, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}

export const layTongHopDangKyDaoTaoNam = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layTongHopDangKyDaoTaoNam + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDSDangKyDaoTao = async () => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layDSDangKyDaoTao)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};
export const layDSDuyetDangKyDaoTao = async (nam: string, idDangKyDaoTaoNam: number = 0) => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layDSDuyetDangKyDaoTao + "?nam=" + nam + "&idDangKyDaoTaoNam=" + idDangKyDaoTaoNam)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layPhoCVPDuyetTongHopDaoTao = async () => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layPhoCVPDuyet)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layPhoGiamDocDuyetTongHopDaoTao = async () => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layPhoGiamDocDuyet)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layChanhVPDuyetTongHopDaoTao = async () => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layChanhVPDuyet)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layGiamDocDuyetTongHopDaoTao = async () => {
    var rs: any;
    await intance.get(ApiPaths.dangKyDaoTao.layGiamDocDuyet)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuDangKyDaoTaoNam = async (data: any) => {
    const formData = new FormData();
    formData.append("id", (!!data.id ? data.id : "").toString());
    formData.append("ten", data.ten?.toString() || "");
    formData.append("nam", data.nam ? dayjs(data.nam).toISOString() : "");
    formData.append("ngayBatDau", data.ngayBatDau ? dayjs(data.ngayBatDau).toISOString() : "");
    formData.append("ngayKetThuc", data.ngayKetThuc ? dayjs(data.ngayKetThuc).toISOString() : "");
    formData.append("idPhoCVP", (data.idPhoCVP || 0).toString());
    formData.append("idPhoGiamDoc", (data.idPhoGiamDoc || 0).toString());
    formData.append("idChanhVP", (data.idChanhVP || 0).toString());
    formData.append("idGiamDoc", (data.idGiamDoc || 0).toString());
    if (data.kinhPhiDuPhong !== undefined && data.kinhPhiDuPhong !== null) {
        formData.append("kinhPhiDuPhong", data.kinhPhiDuPhong.toString());
    }
    (data.files || []).forEach((file: any) => {
        formData.append("files", file);
    });
    (data.idsTaiLieuXoa || []).forEach((item: number) => {
        formData.append("idsTaiLieuXoa", item.toString());
    });
    return await intance.post(ApiPaths.dangKyDaoTao.luuDangKyDaoTaoNam, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
            return res.data.duLieu;
        })
        .catch(err => {
            throw err;
        });
}
export const luuBanHanhDangKyDaoTao = async (request: any) => {
    const formData = new FormData();
    formData.append("id", (!!request.id ? request.id : "").toString());
    formData.append("maVanBan", request.maVanBan?.toString() || "");
    formData.append("ngayKyVanBan", request.ngayKyVanBan?.toString() || "");
    formData.append("soVanBan", request.soVanBan?.toString() || "");
    request.files.forEach((file, index) => {
        formData.append("files", file);
    })
    await intance.post(ApiPaths.dangKyDaoTao.banHanhDangKyDaoTaoNam, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};
export const luuNoiDungDangKyDaoTaoNam = async (data: any) => {
    var rs: any;
    await intance.post(ApiPaths.dangKyDaoTao.luuNoiDungDangKyDaoTaoNam, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            } else {
                rs = res.data.duLieu;
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
}
export const pheDuyetTongHopDKDT = async (data: any) => {
    var rs: any;
    await intance.post(ApiPaths.dangKyDaoTao.pheDuyetTongHopDKDT, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            } else {
                rs = res.data.duLieu;
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
}
/**
 * Người duyệt cuối cùng duyệt / từ chối các chi tiết đăng ký trong bản tổng hợp
 */
export const duyetChiTietTongHopDKDT = async (data: any) => {
    var rs: any;
    await intance.post(ApiPaths.dangKyDaoTao.duyetChiTietTongHopDKDT, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            } else {
                rs = res.data.duLieu;
            }
        })
        .catch(err => {
            throw err;
        });
    return rs;
}
export const pheDuyetLopDaoTao = async (data: any) => {
    await intance.post(ApiPaths.dangKyDaoTao.pheDuyetLopDaoTao, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            } 
        })
        .catch(err => {
            throw err;
        });
    return rs;
}
export const luuDangKyDaoTao = async (data: any) => {
    await intance.post(ApiPaths.dangKyDaoTao.luuDangKyDaoTao, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const layChiTietDangKyDaoTaoNam = async (id: number) => {
    var data = {};
    await intance.get(ApiPaths.dangKyDaoTao.layCT + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data; 
}
export const thuHoiDangKyDaoTao = async (rq: any) => {
    var data = {};
    await intance.post(ApiPaths.dangKyDaoTao.thuHoiDangKyDaoTao, rq)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}
export const vanPhongTuChoiDKDT = async (rq: any) => {
    var data = {};
    await intance.post(ApiPaths.dangKyDaoTao.vanPhongTuChoi, rq)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}
export const xoaDangKyDaoTao = async (id: number) => {
    var data = {};
    await intance.post(ApiPaths.dangKyDaoTao.xoaDangKyDaoTao + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layChiTietDangKyDaoTao = async (id: number, idDangKyDaoTaoNam: number) => {
    var data = {};
    await intance.get(ApiPaths.dangKyDaoTao.layCTDangKyDaoTao + "?id=" + id + "&idDangKyDaoTaoNam=" + idDangKyDaoTaoNam)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao || "Có lỗi xảy ra");
            }
        })
        .catch((err) => {
            throw err;
        });
    return data; 
}

export const layDSLopThamGia = async (idDangKyDaoTaoNam: number, idNhomDaoTao: number) => {
    var data: any = [];
    await intance.get(ApiPaths.dangKyDaoTao.layDSLopThamGia + "?idDangKyDaoTaoNam=" + idDangKyDaoTaoNam + "&idNhomDaoTao=" + idNhomDaoTao)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao || "Có lỗi xảy ra");
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const xoaDangKyDaoTaoNam = async (id: number) => {
    await intance.post(ApiPaths.dangKyDaoTao.xoa + "?id=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const timKiemDSLopDaoTaoTheoKH = async (tuKhoa: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.daoTao.timKiemDSLopDaoTaoTheoKH, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": tuKhoa
        },
        "orderBy": {
            "columnName": "ten",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const timKiemDSLopDaoTao = async (tuKhoa: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.daoTao.timKiemDSLopDaoTao, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": tuKhoa
        },
        "orderBy": {
            "columnName": "ten",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuLopDaoTao = async (data: any) => {
    const formData = new FormData();
    formData.append("id", (!!data.id ? data.id : "").toString());
    formData.append("lyDo", data.lyDo?.toString() || "");
    formData.append("ma", data.ma?.toString() || "");
    formData.append("ten", data.ten?.toString() || "");
    formData.append("moTa", data.moTa?.toString() || "");
    formData.append("giangVien", data.giangVien?.toString() || "");
    formData.append("diaDiemToChuc", data.diaDiemToChuc?.toString() || "");
    formData.append("donViDaoTao", data.donViDaoTao?.toString() || "");
    formData.append("hocPhi", (data.hocPhi || 0).toString());
    formData.append("idHinhThucToChuc", (data.idHinhThucToChuc || 0).toString());
    formData.append("ngayBatDau", data.ngayBatDau ? dayjs(data.ngayBatDau).toISOString() : "");
    formData.append("ngayKetThuc", data.ngayKetThuc ? dayjs(data.ngayKetThuc).toISOString() : "");
    formData.append("idNVTheoDoi", (data.idNVTheoDoi || 0).toString());
    formData.append("idPhoCVP", (data.idPhoCVP || 0).toString());
    formData.append("idChanhVP", (data.idChanhVP || 0).toString());
    formData.append("idPhoGiamDoc", (data.idPhoGiamDoc || 0).toString());
    formData.append("idGiamDoc", (data.idGiamDoc || 0).toString());
    formData.append("isTrinh", (!!data.isTrinh).toString());
    (data.dsNhanVien || []).forEach((item: any, index: number) => {
        if (item.id) {
            formData.append(`dsNhanVien[${index}].id`, item.id.toString());
        }
        formData.append(`dsNhanVien[${index}].idLopDaoTao`, (item.idLopDaoTao || 0).toString());
        formData.append(`dsNhanVien[${index}].idNhanVien`, (item.idNhanVien || 0).toString());
        formData.append(`dsNhanVien[${index}].diemDanhGia`, item.diemDanhGia?.toString() || "");
        formData.append(`dsNhanVien[${index}].ketQuaDaoTao`, item.ketQuaDaoTao?.toString() || "");
        formData.append(`dsNhanVien[${index}].isCapChungChi`, (!!item.isCapChungChi).toString());
    });
    (data.files || []).forEach((file: any) => {
        formData.append("files", file);
    });
    (data.idsTaiLieuXoa || []).forEach((item: number) => {
        formData.append("idsTaiLieuXoa", item.toString());
    });
    return await intance.post(ApiPaths.daoTao.luu, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
            return res.data.duLieu;
        })
        .catch(err => {
            throw err;
        });
}

export const layChiTiet = async (id: number) => {
    var data = new LopDaoTao;
    await intance.get(ApiPaths.daoTao.chitiet + "?id=" + id)
        .then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        }
    })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const xoaLopDaoTao = async (id: number) => {
    await intance.post(ApiPaths.daoTao.xoa + "?id=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const layDsNhanVienTheoLopDaoTao = async (id: number) => {
    var data = new Array<NhanVienTheoLopDaoTao>;
    await intance.get(ApiPaths.daoTao.layDsNhanVien + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const luuDSNhanVien = async (data: any) => {
    await intance.post(ApiPaths.daoTao.luuDsNhanVien, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

/**
 * Cập nhật kết quả đào tạo của 1 nhân viên trong lớp đào tạo
 * @param data { id: id QuaTrinhDaoTao, idLopDaoTao, diemDanhGia, ketQuaDaoTao, isCapChungChi, chungChi }
 * chungChi: thông tin chứng chỉ nhập kèm khi isCapChungChi = true, để null khi không cấp chứng chỉ
 */
export const capNhatKetQuaDaoTao = async (data: any) => {
    await intance.post(ApiPaths.daoTao.capNhatKetQuaDaoTao, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

/**
 * Hoàn thành lớp đào tạo (chuyển trạng thái lớp sang Hoàn thành)
 * @param id id lớp đào tạo
 */
export const hoanThanhLopDaoTao = async (id: number) => {
    await intance.post(`${ApiPaths.daoTao.hoanThanhLopDaoTao}?id=` + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const luuDangKyDaoTaoBoSung = async (data: any) => {
    await intance.post(ApiPaths.daoTao.luuDangKyDaoTaoBoSung, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const khoiTaoLopDaoTaoKeHoach = async (data: any) => {
    await intance.post(ApiPaths.daoTao.khoiTaoLopDaoTaoKeHoach, data)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const layTongHopDaoTao = async (tuNgay?: string, denNgay?: string) => {
    var rs: any;
    const params = new URLSearchParams();
    if (tuNgay) params.append('tuNgay', tuNgay);
    if (denNgay) params.append('denNgay', denNgay);
    await intance.get(`${ApiPaths.daoTao.layTongHopDaoTao}?${params.toString()}`)
        .then(res => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => { throw err; });
    return rs;
};

export const layThongKeDaoTaoTheoDonVi = async (tuNgay?: string, denNgay?: string) => {
    var rs: any[] = [];
    const params = new URLSearchParams();
    if (tuNgay) params.append('tuNgay', tuNgay);
    if (denNgay) params.append('denNgay', denNgay);
    await intance.get(`${ApiPaths.daoTao.layThongKeDaoTaoTheoDonVi}?${params.toString()}`)
        .then(res => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => { throw err; });
    return rs;
};

export const layDSNhanVienChuaHoanThanhDaoTao = async (tuNgay?: string, denNgay?: string) => {
    var rs: any[] = [];
    const params = new URLSearchParams();
    if (tuNgay) params.append('tuNgay', tuNgay);
    if (denNgay) params.append('denNgay', denNgay);
    await intance.get(`${ApiPaths.daoTao.layDSNhanVienChuaHoanThanhDaoTao}?${params.toString()}`)
        .then(res => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => { throw err; });
    return rs;
};

export const layDSChungChiSapHetHan = async (soNgay: number = 30) => {
    var rs: any[] = [];
    await intance.get(`${ApiPaths.daoTao.layDSChungChiSapHetHan}?soNgay=${soNgay}`)
        .then(res => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => { throw err; });
    return rs;
};

export const layLichSuDaoTaoTheoNhanVien = async (idNhanVien?: number, tuKhoa?: string) => {
    var rs: any[] = [];
    const params = new URLSearchParams();
    if (idNhanVien) params.append('idNhanVien', idNhanVien.toString());
    if (tuKhoa) params.append('tuKhoa', tuKhoa);
    await intance.get(`${ApiPaths.daoTao.layLichSuDaoTaoTheoNhanVien}?${params.toString()}`)
        .then(res => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => { throw err; });
    return rs;
};

export const xoaDangKyDaoTaoBoSung = async (id: number) => {
    await intance.post(`${ApiPaths.daoTao.xoaDangKyDaoTaoBoSung}?id=` + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
};

export const xuatKeHoachDaoTaoNam = async (id: number, soVanBan: string, maVanBan: string, ngayKyVanBan?: Date) => {
    return await intance.post(ApiPaths.dangKyDaoTao.xuatKeHoachDaoTaoNam, 
        { id, soVanBan, maVanBan, ngayKyVanBan },
        { responseType: 'blob' }
    );
};

export const xuatPhieuTrinhDaoTaoNam = async (id: number) => {
    return await intance.get(`${ApiPaths.dangKyDaoTao.xuatPhieuTrinhDaoTaoNam}?id=${id}`, {
        responseType: 'blob'
    });
};
